import useProjectStore from '../components/ProjectCanvas/useProjectStore';

export const getAutoCompleteOptions = options => {
  if (options === undefined || options === null) {
    return;
  }

  const categories = useProjectStore.getState().workflowCategories.filter(c =>
    options.includes(c.categoryId)
  );

  return categories;
};

export const getMarketplaceDialogOptions = options => {
  return options.map(({ categoryId, displayName }) => ({
    displayName,
    categoryId,
  }));
};
